

























































































import store from '../../../store'
import DataTable from '../../../components/DataTable.vue'
import PageTitle from '../../../components/PageTitle.vue'
import Table8 from '../tables/Table8.vue'
import Table9 from '../tables/Table9.vue'
import { stockCalculations } from '../../../mixins/mixins'
import dayjs from 'dayjs'
import Chart from '../../../components/Chart.vue'

export default {
  mixins: [stockCalculations],
  data (this:any) {
    return {
      name: 'Winter 1',
      isDevice: this.$vuetify.breakpoint.width < 768,
      updateChart: 0,
      date: dayjs().format('YYYY-MM-DD'),
      startDate: dayjs().format('YYYY-MM-DD'),
      monthIndex: null,
      menu: false,
      monthlyTData: [[], [], [], []],
      paddock: {
        size: 0,
        currentFeed: 0,
        quality: null,
        wastage: 0,
        growth: 0
      },
      stock1: {
        type: null,
        weight: null,
        state: null,
        pregnancy: null,
        number: 0,
        intake: 0,
        energy: 0
      },
      stock2: {
        type: null,
        weight: null,
        state: null,
        pregnancy: null,
        number: 0,
        intake: 0,
        energy: 0
      },
      stock3: {
        type: null,
        weight: null,
        state: null,
        pregnancy: null,
        number: 0,
        intake: 0,
        energy: 0
      },
      results: {
        intake: 0,
        change: 0,
        final: 0
      },
      theaders: [
        { text: 'Field', value: 'label' },
        { text: 'Data', value: 'data.value' },
        { text: 'Calculations & comments', value: 'notes.message' }
      ]
    }
  },

  // Populate on create if data exists
  created: function (this:any) {
    const stored = store.state.seasonalPasture2
    if (stored !== null) {
      this.name = stored.name
      this.date = stored.date
      this.startDate = stored.startDate
      this.monthIndex = stored.monthIndex
      this.menu = stored.menu
      this.monthlyTData = stored.monthlyTData
      this.paddock = stored.paddock
      this.stock1 = stored.stock1
      this.stock2 = stored.stock2
      this.stock3 = stored.stock3
      this.results = stored.results
      this.theaders = stored.theaders
    }
  },

  // Get tdata for each month on mount
  mounted: function (this:any) {
    this.getMonthlyTData()
  },

  // Update state on component value changes
  updated: function (this:any) {
    store.dispatch('updateSeasonalPasture2', this.$data)
  },

  // Update state on component destroy
  beforeDestroy: function (this:any) {
    store.dispatch('updateSeasonalPasture2', this.$data)
  },

  watch: {
    // Update the date
    startDate: function (this:any, val:any) {
      this.getMonthlyTData()
    },
    // Change the active tdata to the present month
    monthIndex: function (this:any) {
      this.tdata = this.monthlyTData[this.monthIndex]
    },
    // Change the current feed on offer value to the result of the previous month
    tdata: function (this:any) {
      if (this.monthIndex < 3) {
        this.monthlyTData[this.monthIndex + 1][this.monthlyTData[this.monthIndex + 1].map((e:any) => e.code).indexOf('currentFeed')].data.value = isNaN(this.results.final) ? 0 : this.results.final
      }
    }
  },

  computed: {
    monthDates (this:any) {
      let monthDates:any[] = []
      for (let i = 0; i < 5; i++) {
        monthDates.push(this.addMonthsToDate(this.startDate, i))
      }
      return monthDates
    },
    tdata: {
      get: function (this:any) {
        let tdataArr:any = []

        // PADDOCK DETAILS

        let paddockArr:any[] = [
          {
            category: 'paddock',
            code: 'size',
            alpha: 'a',
            label: 'Paddock size',
            data: {
              display: 'input',
              type: 'number',
              value: this.paddock.size,
              suffix: 'ha'
            },
            notes: {
              message: null,
              link: null
            },
            hidden: false
          },
          {
            category: 'paddock',
            code: 'currentFeed',
            alpha: 'b',
            label: 'Feed on offer at ' + this.monthDates[this.monthIndex],
            data: {
              display: this.monthIndex > 0 ? 'text' : 'input',
              type: 'number',
              value: this.paddock.currentFeed,
              suffix: 'Kg DM/ha'
            },
            notes: {
              message: 'See Table 8 for help',
              title: 'Table 8 - Approximate relationship between pasture height and kg green DM/ha (Prograze)',
              table: Table8
            },
            hidden: false
          },
          {
            category: 'paddock',
            code: 'quality',
            alpha: 'c',
            label: 'Pasture quality',
            data: {
              display: 'select',
              type: 'string',
              value: this.paddock.quality,
              items: [
                '40% dig, 4.8 MJ ME/kg - Dry (Dead)',
                '50% dig, 6.5 MJ ME/kg - Dry, perennial',
                '60% dig, 8.2 MJ ME/kg  - Gone to seed',
                '70% dig, 10 MJ ME/kg - Green, grassy',
                '75% dig, 10.8 MJ ME/kg - Green, 15-30% clover',
                '80% dig - 11.6 MJ ME/kg - Green, 60% clover'
              ]
            },
            notes: {
              message: 'See the AWI Feed on Offer Library for help.',
              link: 'http://www.feedonofferlibrary.com'
            },
            hidden: false
          },
          {
            category: 'paddock',
            code: 'wastage',
            alpha: 'd',
            label: 'Consumption Wastage Factor',
            data: {
              display: 'input',
              type: 'number',
              value: this.paddock.wastage,
              suffix: '%'
            },
            notes: {
              message: 'When stock graze pastures, losses occur through trampling and fouling and in summer it is commonly 10—20% of consumption. Use low wastage values for shorter pastures and rotational grazing and higher values if rank pasture and set stocked.',
              link: null
            },
            hidden: false
          },
          {
            category: 'paddock',
            code: 'growth',
            alpha: 'e',
            label: 'Monthly pasture growth',
            data: {
              display: 'input',
              type: 'number',
              value: this.paddock.growth,
              suffix: 'Kg DM/ha/day'
            },
            notes: {
              message: 'See Table 9 for help',
              title: 'Table 9 - Monthly pasture growth rate estimates (Prograze)',
              table: Table9
            },
            hidden: false
          }
        ]

        // ANIMAL CONSUMPTION

        let stockArr:any[] = []
        let alphas = [['f', 'g'], ['h', 'i'], ['j', 'k']]
        for (let i = 1; i <= 3; i++) {
          let currentStock = i === 1 ? this.stock1 : i === 2 ? this.stock2 : this.stock3
          let intakeEnergy = this.getPastureIntakeEnergy(currentStock)
          currentStock.intake = intakeEnergy[0]
          currentStock.energy = intakeEnergy[1]
          let hidden = i > 1
          let stock = [
            {
              category: 'stock ' + i,
              code: 'type',
              label: 'Stock type',
              data: {
                display: 'select',
                type: 'string',
                value: currentStock.type,
                items: ['Cows', 'Weaner Cattle', 'Ewes / Wethers', 'Lambs']
              },
              notes: {
                message: null,
                link: null
              },
              hidden: hidden
            },
            {
              category: 'stock ' + i,
              code: 'weight',
              label: 'Average weight',
              data: {
                display: 'select',
                type: 'string',
                value: currentStock.weight,
                items: this.getWeights(currentStock.type),
                suffix: 'kg/Hd'
              },
              notes: {
                message: null,
                link: null
              },
              hidden: hidden
            },
            {
              category: 'stock ' + i,
              code: 'state',
              label: 'Physiological state',
              data: {
                display: 'select',
                type: 'string',
                value: currentStock.state,
                items: this.getPhysiologicalState(currentStock.type)
              },
              notes: {
                message: null,
                link: null
              },
              hidden: hidden
            },
            {
              category: 'stock ' + i,
              code: 'pregnancy',
              label: 'Twins / singles / not applicable',
              data: {
                display: 'select',
                type: 'string',
                value: currentStock.pregnancy,
                items: currentStock.type === 'Ewes / Wethers' && currentStock.state !== 'Dry' ? ['Twins', 'Singles'] : ['Not Applicable']
              },
              notes: {
                message: null,
                link: null
              },
              hidden: hidden
            },
            {
              category: 'stock ' + i,
              code: 'number',
              alpha: alphas[i - 1][0],
              label: 'Number of animals grazing',
              data: {
                display: 'input',
                type: 'number',
                value: currentStock.number
              },
              notes: {
                message: null,
                link: null
              },
              hidden: hidden
            },
            {
              category: 'stock ' + i,
              code: 'intake',
              alpha: alphas[i - 1][1],
              label: 'Estimated pasture intake (kg DM/Hd/day)',
              data: {
                display: 'text',
                type: 'number',
                value: currentStock.intake
              },
              notes: {
                message: null,
                link: null
              },
              hidden: hidden
            },
            {
              category: 'stock ' + i,
              code: 'energy',
              label: 'Maintenance energy required (MJ ME/Hd/day)',
              data: {
                display: 'text',
                type: 'number',
                value: currentStock.energy
              },
              notes: {
                message: null,
                link: null
              },
              hidden: hidden
            }
          ]
          stockArr = stockArr.concat(stock)
        }

        // RESULTS

        let resultsArr = [
          {
            category: 'results',
            code: 'intake',
            alpha: 'l',
            label: 'Daily intake per ha + wastage (Kg DM/ha/day)',
            data: {
              display: 'text',
              type: 'number',
              value: this.results.intake
            },
            notes: {
              message: '(f × g + h × i + j × k) × (1 + d) ÷ a',
              link: null
            },
            hidden: false
          },
          {
            category: 'results',
            code: 'change',
            alpha: 'm',
            label: 'Growth minus intake (Kg DM/ha/day)',
            data: {
              display: 'text',
              type: 'number',
              value: this.results.change
            },
            notes: {
              message: 'e − l',
              link: null
            },
            hidden: false
          },
          {
            category: 'results',
            code: 'final',
            style: 'green white--text font-weight-bold',
            label: 'Estimated feed on offer at ' + this.monthDates[this.monthIndex + 1] + ' (Kg DM/ha)',
            data: {
              display: 'text',
              type: 'number',
              value: this.results.final
            },
            notes: {
              message: 'b + (m × 31)',
              link: null
            },
            hidden: false
          }
        ]

        tdataArr = paddockArr.concat(stockArr, resultsArr)
        return tdataArr
      },
      set: function (this:any, newValue:any) {
        // Filter each category into seperate array
        let paddock = newValue.filter((e:any) => e.category === 'paddock')
        let stock1 = newValue.filter((e:any) => e.category === 'stock 1')
        let stock2 = newValue.filter((e:any) => e.category === 'stock 2')
        let stock3 = newValue.filter((e:any) => e.category === 'stock 3')
        let results = newValue.filter((e:any) => e.category === 'results')
        // Assign new value to category variables
        paddock.forEach((e:any) => { this.paddock[e.code] = e.data.value })
        stock1.forEach((e:any) => { this.stock1[e.code] = e.data.value })
        stock2.forEach((e:any) => { this.stock2[e.code] = e.data.value })
        stock3.forEach((e:any) => { this.stock3[e.code] = e.data.value })
        results.forEach((e:any) => { this.results[e.code] = e.data.value })
        // Get results
        this.getResults()
      }
    },
    chartOptions (this:any) {
      return {
        responsive: true,
        maintainAspectRatio: false,
         plugins: {
          legend: {
            display: false
          }
        },
        scales: {
          x: {
            beginAtZero: true,
            title: {
              display: true,
              text: 'Month'
            }
          },
          y: {
            beginAtZero: true,
            title: {
              display: true,
              text: 'Feed on offer (Kg DM/Ha)'
            }
          }
        }
      }
    },
    chartData (this:any) {
      let labels:string[] = [this.monthDates[0]]
      let data:number[] = [parseFloat(this.monthlyTData[0][1].data.value)]
      let datasets:Object[] = []
      this.monthlyTData.map((mtd:any, index:number) => {
        labels.push(this.monthDates[index + 1])
        if (mtd[mtd.length - 1]) {
          data.push(parseFloat(mtd[mtd.length - 1].data.value.toFixed(2)))
        }
      })
      datasets.push({
        type: 'bar',
        backgroundColor: ['#00754920', '#00754940', '#00754960', '#00754980', '#007549'],
        borderColor: '#007549',
        data: data,
        fill: true
      })
      return {
        labels: labels,
        datasets: datasets
      }
    }
  },

  methods: {
    // Update the tdata for the active month (month1, month2, ...)
    updateMonthlyTData: function (this:any) {
      let index = this.monthIndex
      this.$set(this.monthlyTData, index, this.tdata)
      this.updateChart += 1
    },

    // Get unique tdata for each month
    getMonthlyTData: function (this:any) {
      const stored = store.state.seasonalPasture2
      // For 4 months
      for (let i = 0; i < 4; i++) {
        // Set month 1 data
        if (i === 0) {
          stored && stored.monthlyTData[0].length > 0
          ? this.$set(this.monthlyTData, 0, stored.monthlyTData[0])
          : this.$set(this.monthlyTData, 0, this.tdata)
        // Set month 2-4 data
        } else {
          let newTData = this.cleanSource(this.tdata)
          // Change start and end dates in labels
          let newStartDate = this.monthDates[i]
          let newEndDate = this.monthDates[i + 1]
          newTData[(newTData.map((e:any) => e.code).indexOf('currentFeed'))].label = 'Feed on offer at ' + newStartDate + ' (Kg DM/ha)'
          newTData[(newTData.map((e:any) => e.code).indexOf('final'))].label = 'Feed on offer at ' + newEndDate + ' (Kg DM/ha)'
          // Change to read only
          newTData[(newTData.map((e:any) => e.code).indexOf('currentFeed'))].data.display = 'text'
          // Push to monthly array
          stored && stored.monthlyTData[i].length > 0
          ? this.$set(this.monthlyTData, i, stored.monthlyTData[i])
          : this.$set(this.monthlyTData, i, newTData)
        }
        // Fixes issue where table modal will only work on month 1
        if (i > 0) {
          this.monthlyTData[i].map((row:any, ix:number) => {
            if (row.notes && row.notes.message) {
              if (row.notes.message.includes('Table 8')) {
                this.monthlyTData[i][ix].notes.table = Table8
              } else if (row.notes.message.includes('Table 9')) {
                this.monthlyTData[i][ix].notes.table = Table9
              }
            }
          })
        }
      }
    },

    // Get the final results from previous calculations
    getResults: function (this:any) {
      // Daily intake
      this.results.intake = (this.stock1.number * this.stock1.intake + this.stock2.number * this.stock2.intake + this.stock3.number * this.stock3.intake) * (1 + (this.paddock.wastage / 100)) / this.paddock.size || 0
      // Change in Feed on offer (FOO)
      this.results.change = this.paddock.growth - this.results.intake || 0
      // Number of days paddock will last
      this.results.final = parseInt(this.paddock.currentFeed) + (this.results.change * 31) || 0
    },

    // Update the tdata with new values
    update: function (this:any, row:any) {
      let updatedtData = this.tdata
      let oldRow = updatedtData.filter((e:any) => e.category === row.category && e.code === row.code)
      updatedtData[this.tdata.indexOf(oldRow[0])] = row
      this.tdata = updatedtData
      this.tdata.filter((e:any) => e.category === row.category).forEach((e:any) => { e.hidden = false })
      this.updateMonthlyTData()
    },

    // Add months to formatted date string dd/mm/yyyy
    addMonthsToDate: function (this:any, date:any, increment:number) {
      return dayjs(date).add(increment, 'months').format('DD/MM/YYYY')
    },

    // Using native JSON functions removes reactivity
    // so we can clone an object without mutating the original source
    cleanSource: function (source:any) {
      return JSON.parse(JSON.stringify(source))
    },

    // Load scenario data
    loadScenario: function (this:any, item:any) {
      setTimeout(() => {
        this.tdata = this.cleanSource(item.data1[this.monthIndex])
        this.$set(this.monthlyTData, 0, this.cleanSource(item.data1[0]))
        this.$set(this.monthlyTData, 1, this.cleanSource(item.data1[1]))
        this.$set(this.monthlyTData, 2, this.cleanSource(item.data1[2]))
        this.$set(this.monthlyTData, 3, this.cleanSource(item.data1[3]))
        this.startDate = item.data2
        this.updateChart += 1
      }, 300);
    }
  },

  components: {
    DataTable, PageTitle, Chart
  },

  store
}
